import React from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'

export default function Menus(props) {
  return (
    <Menu
      mode="horizontal"
      theme="light"
      defaultSelectedKeys={[props.defaultKey]}
    >
      <Menu.Item key="license">
        <Link to="/honor/license" key="license">
          <span>资质牌照</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="travel">
        <Link to="/honor/travel" key="travel">
          <span>出国游</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="yearhero">
        <Link to="/honor/yearhero" key="yearhero">
          <span>年度表彰</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="quarterhero">
        <Link to="/honor/quarterhero" key="quarterhero">
          <span>上将标杆</span>
        </Link>
      </Menu.Item>
    </Menu>
  )
}
